// extracted by mini-css-extract-plugin
export default {"themeColor":"var(--primary-color)"};